import { useCallback } from "react";
import { SuppliersApi, useAPIAction } from "melco-shared-logic";

export interface AddSupplierProductButtonInterface {
  code: string;
  supplier_id: string;
  name: string;
}

export const useAddSupplierProduct = () => {
  const [AddSupplierProduct] = useAPIAction(
    SuppliersApi,
    async (api, AddSupplierProductData: AddSupplierProductButtonInterface) => {
      const data = await api.supplierProductDraftCreate({
        controlcenterMelcoModelsCreateSupplierProduct: {
          code: AddSupplierProductData.code,
          name: AddSupplierProductData.name,
          supplier_id: AddSupplierProductData.supplier_id,
        },
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "supplierproducts.actions.add",
    }
  );

  return useCallback(
    async (AddActionDetails: AddSupplierProductButtonInterface) => {
      return await AddSupplierProduct(AddActionDetails);
    },
    [AddSupplierProduct]
  );
};
